// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__3H2vm","head":"ProcedureTableInfo_head__1ktE9"};